const mimeStartsWith = (object, string) => {
  let obj = object;
  if (obj.attachments) {
    [obj] = obj.attachments;
  }
  const mime = obj?.mimeType;
  if (typeof mime !== 'string' || typeof string !== 'string') {
    return false;
  }
  return mime.toLowerCase().startsWith(string.toLowerCase());
};

export default mimeStartsWith;
